<template>
     <div class="row col-12" id="page-heading">
        <span @click="onClick" id="user-icon" :class="pointerCursor ? 'cursor-pointer' : ''">
            <icon :icon="icon"/>
        </span>
        <h5 v-if="title" id="page-title">{{title}}</h5>
    </div>
</template>

<script>
export default {
    props: {
        icon: String,
        title: String,
        pointerCursor: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>

<style lang="scss" scoped>
#page-heading {
    align-items: center;
    span {
        vertical-align: middle;
    }
    #user-icon {
        color: white;
        background-color: #3D9400;
        border-radius: 50%;
        padding-top: 0.55em;
        width: 2.6em;
        height: 2.6em;
        font-size: 1.8em;
        text-align: center;
    }
    #page-title {
        margin-left: 0.8%;
    }
}
.cursor-pointer {
    cursor: pointer;
}
</style>